var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-danger",attrs:{"role":"alert"}},[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.parsedError.message))])]),_vm._v(" "),(_vm.parsedError.errors)?_c('ul',_vm._l((_vm.parsedError.errors),function(error){return _c('li',[_vm._v(_vm._s(error))])}),0):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea4ee62e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Generic/FormError.vue
// module id = null
// module chunks = 